import React, { useEffect } from "react";
import { useData } from "../../../../../components/SiteMap/contexts/DataContext";
import SiteMapBoundaryRoute from "../../../../../components/SiteMap/routes/BoundaryRoute";
import { useMap } from "@vis.gl/react-google-maps";

const SiteMapSetupBoundaryPage = () => {
  const { boundary, setBoundary } = useData();
  const map = useMap();

  useEffect(() => {
    if (!boundary && map) {
      let timeoutId: ReturnType<typeof setTimeout> | null = null;
      let attempts = 0;
      const maxAttempts = 50; // Maximum 10 seconds (50 * 200ms)

      // unclear how long it'll take for map bounds to be ready
      // so we poll every 200ms until we get them, or hit our max attempts
      const checkBoundsAndCreateBoundary = () => {
        attempts++;
        const bounds = map.getBounds();

        if (bounds) {
          // console.log(
          //   `[${new Date().toISOString()}] Map bounds available after ${attempts} attempts`,
          // );

          const ne = bounds.getNorthEast();
          const sw = bounds.getSouthWest();
          const center = bounds.getCenter();

          // Calculate inset of 50% from edges
          const latRange = (ne.lat() - sw.lat()) * 0.25; // 25% on each side = 50% total inset
          const lngRange = (ne.lng() - sw.lng()) * 0.25; // 25% on each side = 50% total inset

          // Create a rectangular boundary inset from the map bounds
          const coords = [
            [center.lat() + latRange, center.lng() - lngRange], // NW
            [center.lat() + latRange, center.lng() + lngRange], // NE
            [center.lat() - latRange, center.lng() + lngRange], // SE
            [center.lat() - latRange, center.lng() - lngRange], // SW
            [center.lat() + latRange, center.lng() - lngRange], // Close the polygon
          ];

          // populate an initial boundary so we have something to edit
          const newBoundary = {
            id: 1,
            coords: coords,
            color: "red",
          };
          setBoundary(newBoundary);
        } else if (attempts < maxAttempts) {
          // console.log(
          //   `[${new Date().toISOString()}] Map bounds not ready, attempt ${attempts}/${maxAttempts}`,
          // );
          timeoutId = setTimeout(checkBoundsAndCreateBoundary, 200);
        } else {
          console.error(
            `[${new Date().toISOString()}] No map bounds available after ${maxAttempts} attempts (${maxAttempts * 200}ms) - user cant build a boundary`,
          );
        }
      };

      // Start the recursive checking
      timeoutId = setTimeout(checkBoundsAndCreateBoundary, 200);

      return () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
      };
    }
  }, [boundary, setBoundary, map]);

  return (
    <>
      <SiteMapBoundaryRoute boundary={boundary} initialSetup={true} />
    </>
  );
};

export default SiteMapSetupBoundaryPage;
